import { createStore } from 'vuex'
import { userinfo } from '@/utils/api'

export default createStore({
  state: {
    url: new URL(window.location.href),
    loading: false,
    oss_client_config: null,
    userInfo: null,
    indexData: null,
    audioPlaying: null,
  },
  getters: {
    api: ({ url }) => {
      const { protocol, hostname } = url
      let domain = hostname.substring(hostname.indexOf('.') + 1)
      let api = `${protocol}//u.${domain}`
      return api
    },
  },
  mutations: {
    loading(state, payload = {}) {
      state.loading = payload
    },
    oss_client_config(state, payload = {}) {
      state.oss_client_config = payload
    },
    userInfo(state, payload = {}) {
      state.userInfo = payload
    },
    indexData(state, payload = {}) {
      state.indexData = payload
    },
    audioPlaying(state, payload = {}) {
      state.audioPlaying = payload
    },
  },
  actions: {
    userInfo({ commit }, payload = {}) {
      return userinfo(payload.fields, payload.config).then(({ data: res }) => {
        commit('userInfo', res.data)
      })
    },
  },
  modules: {},
})
